import React from 'react';

import { Row, Column, Margin } from '@upgrade/react-components';

import { Section } from '../../common/styles';
import Fluid from '../../Fluid';
import useTrustpilot from '../../../utils/useTrustpilot';
import { Heading } from '../../common/TypographyPublicSite';
import { StyledTrustPilotContainer } from './styles';

const ReviewsCount = ({ reviews: { title, snippet }, borderless, topMargin = 'none' }) => {
  useTrustpilot();

  return (
    <Margin top={topMargin}>
      <Section data-color="backgroundPrimary" padding="none" borderless={borderless}>
        <Fluid>
          <Row xsHorizontalAlign="center">
            <Column xs={12} sm={10}>
              {title && <Heading className="section">{title}</Heading>}
              <StyledTrustPilotContainer>
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: snippet }} />
              </StyledTrustPilotContainer>
            </Column>
          </Row>
        </Fluid>
      </Section>
    </Margin>
  );
};

export default ReviewsCount;
